import { useEffect } from 'react'
import { GrowthBook } from '@growthbook/growthbook'
import { useCurrentUser } from '@/hooks/useCurrentUser'

const gb = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: import.meta.env.VITE_GROWTHBOOK_KEY,
  enableDevMode: Boolean(import.meta.env.VITE_GROWTHBOOK_DEVMODE),
  trackingCallback: (_experiment, _result) => {
    // TODO: Use your real analytics tracking system
  },
})

// Load features asynchronously
const initialized = gb.loadFeatures()

export const booleanFlag = async (flag: string) => {
  await initialized
  return gb.isOn(flag)
}

export const stringFlag = async (flag: string, defaultValue: string) => {
  await initialized
  return gb.getFeatureValue(flag, defaultValue)
}

export const numberFlag = async (flag: string, defaultValue: number) => {
  await initialized
  return gb.getFeatureValue(flag, defaultValue)
}

export const jsonFlag = async <T>(flag: string, defaultValue: T): Promise<T> => {
  await initialized
  return gb.getFeatureValue(flag, defaultValue) as T
}

export const useFeatureFlags = () => {
  const { data } = useCurrentUser()
  const user = data?.user

  useEffect(() => {
    if (user) {
      gb.setAttributes(user)
    }
  }, [user])
}
